import type { IconColor, IconName, IconSize, IconsProps } from '@/core/components/Icons/Icons';
import Icons from '@/core/components/Icons/Icons';

export type { IconColor, IconName, IconSize, IconsProps };
export default Icons;
